/**
 * Shared configuration for list/overview queries that should stay fresh while open.
 */
export const CASES_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  refetchInterval: 30 * 1000, // 30 seconds
} as const;

/**
 * QC list page refreshes through explicit invalidation/user actions.
 * Avoid interval polling here; use push updates if this page needs to auto-refresh.
 */
export const QC_LIST_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  refetchInterval: false,
} as const;

/**
 * QC eval detail should refresh when opened, but it should not poll in the background.
 * Mutations invalidate these queries explicitly.
 */
export const QC_EVAL_DETAIL_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  refetchOnMount: 'always',
} as const;
